import { Routes } from '@angular/router';

import { authGuard } from './features/auth/guards/auth.guard';
import { terminalRoleGuard } from './features/auth/guards/terminal-role.guard';
import { depotContextGuard } from './features/depot-context/guards/depot-context.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () =>
      import('./features/auth/components/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'depot-picker',
    canActivate: [authGuard, terminalRoleGuard],
    loadComponent: () =>
      import('./features/depot-context/components/depot-picker/depot-picker.component').then(
        (m) => m.DepotPickerComponent,
      ),
  },
  {
    path: '',
    canActivate: [authGuard, terminalRoleGuard, depotContextGuard],
    loadComponent: () =>
      import('./features/auth/components/shell/shell.component').then((m) => m.ShellComponent),
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'lookup' },
      {
        path: 'lookup',
        loadComponent: () =>
          import('./features/lookup/lookup.component').then((m) => m.LookupComponent),
      },
      {
        path: 'move',
        loadComponent: () => import('./features/move/move.component').then((m) => m.MoveComponent),
      },
      {
        path: 'loading',
        loadComponent: () =>
          import('./features/loading/loading.component').then((m) => m.LoadingComponent),
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./features/loading/loads-list/loads-list.component').then(
                (m) => m.LoadsListComponent,
              ),
          },
          {
            path: ':visitId/compile',
            data: { hideShellChrome: true },
            loadComponent: () =>
              import('./features/loading/compile-detail/compile-detail.component').then(
                (m) => m.CompileDetailComponent,
              ),
          },
          {
            path: ':visitId/load',
            data: { hideShellChrome: true },
            loadComponent: () =>
              import('./features/loading/load-detail/load-detail.component').then(
                (m) => m.LoadDetailComponent,
              ),
          },
        ],
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
